var getAtPath = function (errors, path) {
    var keys = path.split(".");
    return keys.reduce(function (acc, key) {
        if (acc == null)
            return undefined;
        var normalizedKey = /^\d+$/.test(key) ? Number(key) : key;
        return acc[normalizedKey];
    }, errors);
};
var getErrorMessage = function (errors, path) { var _a; return (_a = getAtPath(errors, path)) === null || _a === void 0 ? void 0 : _a.message; };
export var getIdError = function (errors, basePath) { return getErrorMessage(errors, "".concat(basePath, ".id")); };
export var getOnixError = function (errors, basePath) {
    var _a;
    return (_a = getErrorMessage(errors, "".concat(basePath, ".id"))) !== null && _a !== void 0 ? _a : getErrorMessage(errors, "".concat(basePath, ".value"));
};
